import Logo from "../../assets/Logo.png";
import "./Login.css";
import * as React from "react";
import { isEmail } from "validator";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import Divider from "@mui/material/Divider";
import { forgetPassword } from "../../actions/Auth";
import { useDispatch } from "react-redux";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import Input from "./input";
import {
  Avatar,
  Button,
  Paper,
  Grid,
  Typography,
  Container,
} from "@mui/material";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

const ResetPassword = () => {
  const currentUrl = new URL(window.location.href);
  const domain = currentUrl.host;
  const url = `${currentUrl.protocol}//${domain}/assets-register/resetMyPassword`;
  const [error, setError] = React.useState("");
  const initialState = {
    email: "",
    url,
  };
  const [formData, setFormData] = useState(initialState);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const handleOnSubmit = (e) => {
    e.preventDefault();
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function sendData() {
    if (!isEmail(formData.email)) {
      setError("Invalid email");
      return;
    }
    setError("");
    setErrorMessage(true);
    dispatch(forgetPassword(formData));
  }
  const message = useSelector((state) => state);

  return (
    <Container component={"main"} maxWidth='xs'>
      <Helmet title='Forgot Password | Assets Register' />
      {errorMessage && (
        <Stack sx={{ width: "100%" }} spacing={2}>
          {message.auth.emailSentError && (
            <Alert severity='error'>Error:{message.auth.emailSentError}</Alert>
          )}
          {message.auth.emailSent && (
            <Alert severity='success'>{message.auth.emailSent}</Alert>
          )}
        </Stack>
      )}
      <Paper
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "15%",
        }}
        elevation={3}
        className='paper'>
        <Avatar className='avatar-react' src={Logo}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography variant='h5'>Reset your password</Typography>
        <Divider
          style={{
            width: "100%",
            marginBottom: "20px",
            marginTop: "20px",
          }}></Divider>
        <Typography>
          Please enter your email address to get a link to reset your password
        </Typography>

        <form className='form-react' onSubmit={handleOnSubmit}>
          <Grid container spacing={2}>
            <Input
              className='react-input'
              name='email'
              label={"Email Address"}
              handleChange={handleChange}
              type='email'
            />
          </Grid>
          <span style={{ color: "red" }}>{error}</span>
          <Divider style={{ marginBottom: "10px" }} className='react-divider' />
          <Grid container justifyContent={"flex-end"} spacing={2}>
            <Grid item>
              <Button
                variant='contained'
                style={{ textTransform: "none" }}
                onClick={() => navigate("/assets-register/login")}
                className='react-button'>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={sendData}
                variant='outlined'
                style={{ textTransform: "none" }}
                className='react-button'>
                Get Link
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default ResetPassword;
